import { useWatch, useFormState } from 'react-hook-form';

export const useMutuallyExclusiveDobSsn = ({ control, dobName, ssnName, originalDob, originalSsn, isActive }: any) => {
  const normalize = (v: any) => (v === null || v === undefined ? '' : String(v).trim());

  const watchedDob = useWatch({ control, name: dobName });
  const watchedSsn = useWatch({ control, name: ssnName });

  const { dirtyFields } = useFormState({ control });

  if (!control || !isActive) {
    return { disableDob: false, disableSsn: false };
  }

  const currentDob = normalize(watchedDob);
  const currentSsn = normalize(watchedSsn);

  const originalDobValue = normalize(originalDob);
  const originalSsnValue = normalize(originalSsn);

  const bothOriginallyEmpty = originalDobValue === '' && originalSsnValue === '';

  if (bothOriginallyEmpty) {
    return { disableDob: false, disableSsn: false };
  }

  const dobChanged = dirtyFields?.[dobName] && currentDob !== originalDobValue;

  const ssnChanged = dirtyFields?.[ssnName] && currentSsn !== originalSsnValue;

  return {
    disableDob: ssnChanged,
    disableSsn: dobChanged,
  };
};
